import styled from "@emotion/styled";
import React from "react";

import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";
import { InlineLinkProps } from "@brexhq/next/src/components/shared/Link/types";

const StyledInlineLink = styled(CoreLink)(({ theme }) => {
  return {
    textDecoration: "underline",
    "&:hover": {
      color: theme.colors.accent.primary.background.hover,
    },
    "&:active": {
      color: theme.colors.accent.primary.background.pressed,
    },
    // we need a class so that this has more specificity than Typography Text's "& > a" selector
    "&.legacy": {
      color: theme.colors.accent.primary.background.default,
      textDecoration: "none",
      "&:hover": {
        color: theme.colors.accent.primary.background.hover,
      },
      "&:active": {
        color: theme.colors.accent.primary.background.pressed,
      },
    },
  };
});

export const InlineLink = React.forwardRef<HTMLAnchorElement, InlineLinkProps>(
  function InlineLinkComponent(
    { to, label, target, rel, prefetch, variant, ...defaultProps },
    ref,
  ) {
    return (
      <StyledInlineLink
        ref={ref}
        to={to}
        target={target}
        rel={rel}
        prefetch={prefetch}
        {...defaultProps}
        className={
          variant === "legacy"
            ? `legacy ${defaultProps.className || ""}`
            : defaultProps.className
        }
      >
        {label}
      </StyledInlineLink>
    );
  },
);
